import { ComponentType } from '@angular/cdk/portal/index';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, TemplateRef } from '@angular/core';


@Component({
  selector: 'app-export-list',
  templateUrl: './export-list.component.html',
  styleUrls: ['./export-list.component.scss']
})
export class ExportListComponent implements OnInit {

  constructor(
    private toastr: ToastrService,
    protected dialogRef: MatDialogRef<ComponentType<any> | TemplateRef<any>>
  ) { }

  ngOnInit() {
  }

  exportList() :boolean {
    return true;
  }

  close():boolean {
    return false;
  }

}
